import type { RootState } from "@/app/store/type";

export const selectSearchText = (state: RootState) => state.search.searchText;